/* eslint-disable eqeqeq */
import React, { useState, useCallback, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import {
  API,
  defaultLimitPagination,
  get,
  ProjectStatus,
} from "../../../config";
import Spin from "../../common/Spin";
import Pagination from "../../common/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import ImportLogDetail from "./ImportLogDetail";
import { debounce } from "underscore";
import moment from "moment";
import {
  formatedAddress,
  formatName,
  formatNumber,
  formatPhone,
} from "../../common/Misc";
import SearchBox from "../../common/SearchBox";

const ImportedLogs = ({ builderId }) => {
  var today = new Date();
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [importLogs, setImportLogs] = useState({});
  const [loading, setLoading] = useState(false);
  const [importLogId, setImportLogId] = useState();
  const [importLogModal, setImportLogModal] = useState(false);
  const search = query.get("search");
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");

  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const toggleShowModal = () => {
    setImportLogModal(!importLogModal);
  };

  const handleDetails = (id) => {
    setImportLogId(id);
    setImportLogModal(true);
  };

  // *API Call for Import Logs List - Start
  const fetchImportedLogs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.PROJECT_IMPORT_LOGS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&status=1&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }${builderId ? "&builder_id=" + builderId : ""}`
        );
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        setTotal(data?.data?.total);
        setImportLogs(data?.data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortField, sortOrder, builderId]
  );

  useEffect(() => {
    fetchImportedLogs();
  }, [fetchImportedLogs]);
  // *API Call for Import Logs List - End

  useEffect(() => {
    navigate(
      `/project-import-logs?tab=imported&limit=${
        limit ? limit : defaultLimitPagination
      }&page=${page ? page : 1}&search=${
        searchParam ? searchParam : ""
      }&builder_id=${builderId ? builderId : ""}`,
      { replace: true }
    );
  }, [navigate, page, limit, searchParam, builderId]);

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC"
      );
    }
  };

  const getVerifiedDateTime = (date) => {
    return moment(date).format("DD-MM-YYYY HH:mm:ss").toString();
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - Start
  const importLogsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        builder_id: importLogs[i]?.builder_id,
        key: importLogs[i]?.id,
        project_id: importLogs[i]?.id,
        project_name:
          importLogs[i]?.subscription?.status === 0 ||
          importLogs[i]?.subscription?.status === 1 ? (
            <Link
              to={{
                pathname: `/projects/${importLogs[i]?.id}`,
              }}
              className="project-name-link active"
            >
              {importLogs[i]?.project_name}
            </Link>
          ) : (
            importLogs[i]?.project_name
          ),
        email: importLogs[i]?.email ? importLogs[i]?.email : "-",
        phone: importLogs[i]?.phone ? formatPhone(importLogs[i]?.phone) : "-",
        end_date: importLogs[i]?.end_date ? importLogs[i]?.end_date : "-",
        address: formatedAddress(
          importLogs[i]?.street,
          importLogs[i]?.suburb?.name,
          importLogs[i]?.state?.short_name,
          importLogs[i]?.postal_code
        ),
        status: importLogs[i]?.project_status
          ? importLogs[i]?.project_status == 2 &&
            importLogs[i]?.end_date &&
            new Date(
              importLogs[i]?.end_date?.split("-")?.reverse()?.join("-")
            ) < today
            ? "Delayed"
            : ProjectStatus?.find(
                (item) => item?.value === Number(importLogs[i]?.project_status)
              )?.label
          : "-",
        estimated_cost: importLogs[i]?.estimated_cost
          ? `$${formatNumber(Number(importLogs[i]?.estimated_cost))}`
          : "-",
        imported_by: importLogs[i]?.imported_by
          ? formatName(
              importLogs[i]?.imported_by?.first_name,
              importLogs[i]?.imported_by?.last_name
            )
          : "-",
        import_from: importLogs[i]?.import_from
          ? importLogs[i]?.import_from
          : "BuildTrust",
        project_last_sync_date: importLogs[i]?.project_last_sync_date
          ? getVerifiedDateTime(importLogs[i]?.project_last_sync_date)
          : "-",
        import_date: (
          <span>
            {importLogs[i]?.updated_at
              ? moment(importLogs[i]?.updated_at, "DD-MM-YYYY HH:mm:SS").format(
                  "DD-MM-YYYY"
                )
              : importLogs[i]?.created_at
              ? moment(importLogs[i]?.created_at, "DD-MM-YYYY HH:mm:SS").format(
                  "DD-MM-YYYY"
                )
              : ""}
          </span>
        ),
        action: (
          <>
            <FontAwesomeIcon
              icon={faEye}
              size="1x"
              onClick={() => handleDetails(importLogs[i]?.id)}
            />
          </>
        ),
      });
    }
    return items;
  };

  const importLogsData = importLogsGenerator(importLogs?.length);

  const columns = [
    {
      dataField: "import_date",
      text: "Import Date",
      style: { width: "10%" },
    },
    {
      dataField: "project_name",
      text: "Project Name",
      sort: true,
    },
    // {
    //   dataField: "email",
    //   text: "Email",
    //   sort: true,
    // },
    // {
    //   dataField: "phone",
    //   text: "Phone No.",
    //   sort: true,
    // },
    // {
    //   dataField: "address",
    //   text: "Project Address",
    //   // sort: true,
    // },
    {
      dataField: "end_date",
      text: "End Date",
      // sort: true,
    },
    {
      dataField: "estimated_cost",
      text: "Estimated Cost",
    },
    {
      dataField: "status",
      text: "Project Status",
    },
    {
      dataField: "imported_by",
      text: "Imported By",
      sort: true,
    },
    // {
    //   dataField: "subscribe",
    //   text: "Manage",
    //   align: "center",
    //   headerAlign: "center",
    //   style: { width: "127px" },
    // },
    {
      dataField: "import_from",
      text: "Import From",
    },
    {
      dataField: "project_last_sync_date",
      text: "Last synchronised time",
    },

    {
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "97px" },
    },
  ];

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchImportedLogs(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchImportedLogs(limit, page);
  };

  // *Import Logs List Table Row and Column Generation, Filtering and Sorting of Record, Select Row and Expand Row - End

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    []
  );

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  return (
    <>
      <div className="table-top-btn">
        <SearchBox
          placeholder={"Search Imported Logs"}
          searchParamData={searchParamData}
          handleSearchChange={handleSearchChange}
          handleClearSearch={handleClearSearch}
        />
      </div>
      <div className="audit-statement">
        {loading && <Spin />}
        <BootstrapTable
          keyField="batch_id"
          remote
          data={importLogsData}
          columns={columns}
          onTableChange={handleTableChange}
          noDataIndication="No Data Found"
        />

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>

      {importLogModal && (
        <ImportLogDetail
          toggleShowModal={toggleShowModal}
          importLogId={importLogId}
          importLogModal={importLogModal}
          builderId={builderId}
        />
      )}
    </>
  );
};

export default ImportedLogs;
